import React, { Component } from "react";
import AlumnoEnPagosTabla from "./AlumnoEnPagosTabla";
import { connect } from "react-redux";
import { getAlumnoList } from './AlumnoAction'
import { withRouter } from 'react-router-dom';

class AlumnoEnPagosContainer extends Component {

    componentDidMount() {
        //console.log("AlumnoContainer");
        this.props.dispatch(getAlumnoList());
    }

    render() {
        return (
            <div>
                <AlumnoEnPagosTabla />
            </div>
        );
    }
}

export default connect()(AlumnoEnPagosContainer);
